import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonsConfiguration } from 'src/app/configuration/commons/commons-configuration';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AttachmentsService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  })
  constructor(public http: HttpClient) { }


  // ALLEGATI WELCOME PAGE
  ricercaHomePageAllegati(page: any, size: any) {
    return this.http.get<any[]>(CommonsConfiguration.ricercaHomePageAllegati + '/' + page + '/' + size, { headers: this.headers });
  }

  ricercaNormative(page: any, size: any) {
    return this.http.get<any[]>(CommonsConfiguration.ricercaNormative + '/' + page + '/' + size, { headers: this.headers });
  }

  ricercaDecreti(page: any, size: any) {
    return this.http.get<any[]>(CommonsConfiguration.ricercaDecreti + '/' + page + '/' + size, { headers: this.headers });
  }

  ricercaFigure(page: any, size: any) {
    return this.http.get<any[]>(CommonsConfiguration.ricercaFigure + '/' + page + '/' + size, { headers: this.headers });
  }

  ricercaPercorsiRegolamentati(page: any, size: any) {
    return this.http.get<any[]>(CommonsConfiguration.ricercaPercorsiRegolamentati + '/' + page + '/' + size, { headers: this.headers });
  }


  // DOWNLOAD ALLEGATI
  downloadDocumentoHomePage(data:any)  {
    return this.http.post(CommonsConfiguration.homePageDownloadDocumento, data, { responseType: 'blob' });
  }

  downloadService(data: any, fileName: string) {
    const blob = new Blob([data], {type: 'application/octet-stream'});
    let element = document.createElement('a');
    element.href = window.URL.createObjectURL(blob);
    element.download = fileName;
    element.click();
  }

  downloadManuale(from : string){
    return this.http.get(`${CommonsConfiguration.downloadManuale}/${from}`, {responseType : "blob"});
  }
}
